import React from 'react';
import { Table } from 'antd';

export default function AntTable(props) {
  return <Table {...props} />;
}
